import { DateTimeUtils } from '@servicetitan/datetime-utils';
import { useDependencies } from '@servicetitan/react-ioc';
import { useCallback } from 'react';

export const useFormatDate = (today?: boolean) => {
    const [{ formatShortMonth }] = useDependencies(DateTimeUtils);

    return useCallback(
        (date?: Date) => {
            if (today && date) {
                const today = new Date();

                if (
                    today.getFullYear() === date.getFullYear() &&
                    today.getMonth() === date.getMonth() &&
                    today.getDate() === date.getDate()
                ) {
                    return 'Today';
                }
            }

            return date ? `${formatShortMonth(date)} ${date.getDate()}, ${date.getFullYear()}` : '';
        },

        [formatShortMonth, today]
    );
};
